let _SpinnerSpinners = [];
class Spinner {
    constructor(dom = null, text = null, id = null) {
        this.id = null;
        this.dom = null;
        this.spinnerDom = null;
        this.count = 0;
        this.DOMPosition = undefined;
        this.id = id;
        if (this.id !== null && Spinner.spinners.find((s) => s.id === this.id)) {
            this.addSpinnerToSpinners();
            let el = Spinner.spinners.find((s) => s.id === this.id);
            if (el) {
                this.dom = el.dom ?? null;
                this.spinnerDom = el.spinnerDom ?? null;
            }
            return;
        }
        this.baseSpinner = $("#base_spinner");
        if (!dom) {
            dom = $("body");
        }
        this.dom = $(dom);
        this.spinnerDom = this.baseSpinner.clone();
        this.spinnerDom.attr("id", "").hide();
        if (text !== null) {
            let textDom = $(`<h3>${text}</h3>`);
            let image = this.spinnerDom.find("img");
            let div = this.spinnerDom.find("div");
            div.append(textDom);
            div.css({
                position: "relative",
                width: "100%",
                display: "flex",
                "justify-content": "center",
            });
            textDom.css({ position: "absolute" });
            image.css("position", "absolute");
            textDom.animate({ top: "+=40px" }, "slow");
            image.animate({ top: "-=40px" }, "slow");
        }
        this.addSpinnerToSpinners();
        this.dom.prepend(this.spinnerDom);
        this.setDOMPositionRelative();
        this.spinnerDom.fadeIn(200);
    }
    destroy() {
        let hidden = this.hide();
        if (!hidden) {
            return;
        }
        setTimeout(() => {
            if (this.spinnerDom) {
                this.spinnerDom.remove();
            }
        }, 500);
    }
    show() {
        this.addSpinnerToSpinners();
        this.setDOMPositionRelative();
        if (this.spinnerDom) {
            this.spinnerDom.fadeIn(200);
        }
    }
    hide() {
        if (this.id !== null) {
            let index = Spinner.spinners.findIndex((s) => s.id === this.id);
            Spinner.spinners[index].count--;
            if (Spinner.spinners[index].count > 0) {
                return false;
            }
            else {
                Spinner.spinners.splice(index, 1);
            }
        }
        this.restoreDOMPosition();
        if (this.spinnerDom) {
            this.spinnerDom.fadeOut(200);
        }
        return true;
    }
    setDOMPositionRelative() {
        if (this.dom && !this.dom.is("body")) {
            this.DOMPosition = this.dom.css("position");
            this.dom.css("position", "relative");
        }
    }
    restoreDOMPosition() {
        if (this.dom && !this.dom.is("body")) {
            this.dom.css("position", this.DOMPosition || "initial");
        }
    }
    addSpinnerToSpinners() {
        if (this.id !== null && Spinner.spinners.find((s) => s.id === this.id)) {
            const spinner = Spinner.spinners.find((s) => s.id === this.id);
            if (spinner) {
                spinner.count++;
            }
        }
        else {
            Spinner.spinners.push({
                id: this.id,
                dom: this.dom,
                spinnerDom: this.spinnerDom,
                count: 1,
            });
        }
    }
    static get spinners() {
        return _SpinnerSpinners;
    }
}
export { Spinner };
